import { fetchAuthToken } from '../api/notifications'
import type { Resolvers } from '../generated/server/resolvers'

const NotificationsResolver: Resolvers = {
  Query: {
    getNotificationsToken: async () => await fetchAuthToken(),
  },
}

export default NotificationsResolver
